import { createAction, props } from '@ngrx/store';
import { Place } from '../models/generated/Place.generated';
import { WeatherForecastHourGroup } from '../models/generated/WeatherForecastHourGroup.generated';

export const openDetails = createAction(
    '[POIS] Open details',
    props<{ place: Place; switchView: boolean; }>()
);